<template>
  <div class="text-center d-flex align-center">
    <v-menu v-model="menuPerfil" min-width="250px" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar color="#086318" size="36" v-bind="attrs" v-on="on" class="mr-2">
          <span class="white--text text-h6">{{ resource.initials }}</span>
        </v-avatar>
      </template>

      <v-card>
        <v-list-item-content class="justify-center">
          <div class="pa-5 text-left">
            <div class="box">
              <v-avatar color="green" class="mr-2" size="26">
                <span class="white--text">{{ resource.initials }}</span>
              </v-avatar>
              <div class="box-name">
                <small class="saudacao">Olá,</small>
                <h5>{{ resource.fullName }}</h5>
              </div>
            </div>

            <div class="box-infos">
              <span>Email</span>
              <span class="text-caption mt-1">
                {{ resource.email }}
              </span>
            </div>

            <div class="box-btn-actions text-center">
              <v-divider class="my-3"></v-divider>
                <NewPass :resource="btnName" />
              <v-divider class="my-3"></v-divider>
                <v-btn depressed rounded text @click="openChangeProfileMenu">
                  {{ $t('buttons.change_profile') }}
                </v-btn>
              <v-divider class="my-3"></v-divider>
                <v-btn depressed rounded text @click="logout">
                  {{ $t('buttons.disconect') }}
                </v-btn>
            </div>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>

    <v-menu v-model="menuAlertas" min-width="300px" offset-y v-if="showAlertsMenu">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" style="position: relative; display: inline-block">
          <v-avatar color="#3a995a" size="36">
            <v-icon class="white--text text-h6">mdi-bell</v-icon>
          </v-avatar>

          <v-badge v-if="Number(alertQuantity) >= 1" :content="alertQuantity" color="red" overlap offset-x="12"
            offset-y="12" style="position: absolute; top: 0; right: 0" />
        </div>
      </template>

      <v-card class="mx-auto rounded-lg" max-width="auto" elevation="4">
        <v-list flat class="alerts-menu-list  alerts-menu-card">
          <div>
            <v-list-item class="d-flex justify-center" v-for="(item, i) in alerts" :key="i"
              @click.stop="viewAlert(item.id)">
              <div class="pr-6 pl-6 pt-4 pb-4 mb-2" style="
                  border: 1px solid #ccc;
                  border-radius: 15px;
                  width: 280px;
                  display: block;
                  word-wrap: break-word;
                ">
                <v-icon class="mr-2" :color="item.viewed != 0 ? 'green' : undefined">
                  {{
                    item.viewed == 0
                      ? "mdi-checkbox-blank-circle-outline"
                      : "mdi-checkbox-marked-circle"
                  }}
                </v-icon>
                <small>{{ item.messages }}</small>
                <br>
                <small class="item-date">{{ formatHoraDataBr(item.created_at) }}</small>
              </div>
            </v-list-item>
          </div>
        </v-list>
        <v-card-actions class="d-flex justify-center" v-if="hasAlerts">
          <v-btn text large color="#41916b" @click="clearAlerts">
            {{ $t('buttons.clean_up') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu> 

    <v-dialog v-model="menuChangeProfile" persistent max-width="350px">
      <MenuChangeProfile :profiles="activeProfiles" @closeModal="menuChangeProfile = false"/>
    </v-dialog>
  </div>
</template>
<script>
import axios from "@/axios";
import NewPass from "../login/NewPassword-comp.vue";
import currentUser from "@/utils/currentUser"; 
import Formatters from "@/utils/Formatters"; 
import MenuChangeProfile from "./MenuChangeProfile-comp.vue";
import { AbilityMixin } from "@/mixins/ability.mixin";
import { mapActions } from "vuex"; 
export default {
  mixins: [AbilityMixin],
  data() {
    return {
      btnName: this.$t('buttons.change_password'),
      alertQuantity: "",
      alerts: [],
      menuPerfil: false,
      menuAlertas: false, 
      menuChangeProfile: false
    };
  },

  props: {
    resource: {
      type: Object,
    },
  },

  components: {
    NewPass,
    MenuChangeProfile
  },

  mounted() { 
    this.checkAlerts(); 
  },
 
  watch: {
    menuPerfil(val) {
      if (val) this.menuAlertas = false;
    },
    menuAlertas(val) {
      if (val) this.menuPerfil = false;
    },
  },

  computed: { 
    currentUser() {
      return this.getCurrentSession;
    },

    activeProfiles() {
      return this.currentUser?.profiles || []
    },
    profile() {
      const userData = currentUser.getUserData()
      return userData.profile
    },

    showAlertsMenu() {
      return this.currentUser?.abilities?.some((ability) =>
        [
          'list_alerts', 
        ].includes(ability)
      ) ?? false
    },

    hasAlerts() {
      return this.alertQuantity >= 1
    }
  },

  methods: {
    ...mapActions([
      "changeSnackBarData", 
    ]),
    
    formatHoraDataBr: Formatters.formatHoraDataBr,

    openChangeProfileMenu() {
      this.menuPerfil = false;
      this.menuChangeProfile = true;
    },

    logout() {
      localStorage.removeItem("token");
      this.$router.push("/");
    },

    checkAlerts() {
      axios.get(`/alerts`).then((response) => {
        this.alertQuantity = response.data.new >= 1 ? response.data.new : "";
        this.alerts = response.data.alert;
      });
    },

    viewAlert(id) {
      let data = new Object();
      data.id = id;

      axios.post(`/alerts/viewed`, data).then(() => {
        this.checkAlerts();
      });
    },

    clearAlerts() { 
      const currentProfileId = this.currentUser.profile_id 
        axios.delete(`/alerts/deleted_viewed/${currentProfileId}`).then((response) => {
          this.checkAlerts();
          this.changeSnackBarData({
            status: true,
            type: "success",
            titleMessage: response.data.message,
            bodyMessage: "",
            cardColor: "#41916b",
            titleIcon: "mdi-checkbox-marked-circle",
          });

          setTimeout(() => { 
            this.closeSnackBar();
          }, 3000); 
        }).catch((err) => {
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: err.error, 
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);
        }) 
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    }
  },
};
</script>
<style>
.item-date {
  font-size: 11px;
  color: #086318;
}

.v-menu__content {
  box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px !important;
}

.alerts-menu-card {
  max-height: 420px;
  overflow: hidden;
}

.alerts-menu-list {
  max-height: 420px;
  overflow-y: auto;
  padding-right: 4px;
}

.box {
  display: flex;
  align-items: center;
}

.box-infos {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.box-infos>span {
  font-size: 12px;
  margin-bottom: -3px;
  font-weight: 600;
}

.box-name {
  display: flex;
  flex-direction: column;
}

.box-name>small {
  font-size: 11px;
}

.box-name>h5 {
  font-size: 14px;
}
</style>
